/**
 * widget 统一控制台 logger。
 *
 * 所有输出都以 `[数智客服]`（可选子模块）开头，便于在客户站点混杂的 console 噪音里
 * 一眼定位是哪个组件的日志。
 *
 * 用法：
 *   import { dcsLog } from '@/services/logger';
 *   dcsLog.info('boot', { clientId });
 *   dcsLog.warn('transport', 'ai.error', payload);
 *   dcsLog.error('config', '加载失败', err);
 */

const PREFIX = '[数智客服]';

function format(parts: unknown[]): unknown[] {
  // 把首段字符串合并到 PREFIX 后面，让浏览器能合并相邻字符串渲染；
  // 非字符串保持原样作为后续参数（保留对象的可展开预览）。
  const [first, ...rest] = parts;
  if (typeof first === 'string') {
    return [`${PREFIX} ${first}`, ...rest];
  }
  return [PREFIX, ...parts];
}

export const dcsLog = {
  info(...parts: unknown[]): void {
    // eslint-disable-next-line no-console
    console.info(...format(parts));
  },
  warn(...parts: unknown[]): void {
    // eslint-disable-next-line no-console
    console.warn(...format(parts));
  },
  error(...parts: unknown[]): void {
    // eslint-disable-next-line no-console
    console.error(...format(parts));
  },
};
